export class TransferForloebDataRequestModel {
    constructor(deaktiveretForloebId: string, forloebToUpdateId: string) {
        this.deaktiveretForloebId = deaktiveretForloebId;
        this.forloebToUpdateId = forloebToUpdateId;
    }

    public deaktiveretForloebId: string;
    public forloebToUpdateId: string;
}
